module.exports = __webpack_public_path__ + "img/message-circle-white.72fca4af.svg";